module.exports = __webpack_public_path__ + "static/media/logo.c9c408ed.svg";